// DEPRECATED: appointmentsV3 routes are commented out in dashboard.routes.js.
// Do not proxy VUE_APP_KNOWLEDGE_API usage here — this is dead code.
import appConfig from '../../../shared/helpers/appConfig';const state = {
  appointmentList: [],
  selectedAppointment: null,

  pagination: {
    page: 1,
    page_size: 10,
    total: 0,
    next: null,
  },

  filters: {
    status: null,
    customer_id: null,
    branch_id: null,
    staff_id: null,
    service_id: null,
    conversation_id: null,
    label: null,
    start_date: null,
    end_date: null,
    sort_by: 'date',
    sort_order: 'asc',
  },

  statusCounts: {},

  isLoading: false,
  isError: false,
};

const getters = {
  formattedPagination: (state) => {
    const { page, total, next, page_size } = state.pagination;
    return {
      currentPage: page,
      totalPages: Math.max(1, Math.ceil(total / page_size)),
      nextPage: next,
      pageSize: page_size,
    };
  },
};

const mutations = {
  SET_APPOINTMENTS(state, list) {
    state.appointmentList = list;
  },
  SET_SELECTED_APPOINTMENT(state, appointment) {
    state.selectedAppointment = appointment;
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = pagination;
  },
  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters };
  },
  SET_STATUS_COUNTS(state, counts) {
    state.statusCounts = counts;
  },
  SET_IS_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_IS_ERROR(state, isError) {
    state.isError = isError;
  },
};

const actions = {
  async fetchAppointments({ commit, rootGetters, state }) {
    try {
      commit('SET_IS_LOADING', true);
      commit('SET_IS_ERROR', false);

      const params = {
        page: state.pagination.page,
        page_size: state.pagination.page_size,
        status: state.filters.status,
        customer_id: state.filters.customer_id,
        branch_id: state.filters.branch_id,
        staff_id: state.filters.staff_id,
        service_id: state.filters.service_id,
        conversation_id: state.filters.conversation_id,
        label: state.filters.label,
        start_date: state.filters.start_date,
        end_date: state.filters.end_date,
        sort_by: state.filters.sort_by,
        sort_order: state.filters.sort_order,
      };

      const res = await axios.get(
        `${apiUrl}/v2/accounts/${rootGetters.getCurrentAccountId}/appointments`,
        {
          headers: getCentralHeaders(),
          params,
        }
      );

      const { results, page, total, next, counts } = res.data;

      commit('SET_APPOINTMENTS', results);
      commit('SET_STATUS_COUNTS', counts);
      commit('SET_PAGINATION', {
        ...state.pagination,
        page,
        total,
        next,
      });

      return res.data;
    } catch (error) {
      console.error('Fetch appointments failed:', error);
      commit('SET_IS_ERROR', true);
      throw error.response?.data || error;
    } finally {
      commit('SET_IS_LOADING', false);
    }
  },

  async getAppointment({ commit, rootGetters }, appointmentId) {
    try {
      const res = await axios.get(
        `${apiUrl}/v2/accounts/${rootGetters.getCurrentAccountId}/appointments/${appointmentId}`,
        { headers: getCentralHeaders() }
      );

      commit('SET_SELECTED_APPOINTMENT', res.data);
      return res.data;
    } catch (error) {
      console.error('Get appointment failed:', error);
      throw error.response?.data || error;
    }
  },

  async updatePaginationAndFetch({ commit, dispatch, state }, newPagination) {
    try {
      commit('SET_PAGINATION', { ...state.pagination, ...newPagination });
      await dispatch('fetchAppointments');
      return true;
    } catch (error) {
      console.error('Update pagination and fetch failed:', error);
      throw error.response?.data || error;
    }
  },

  async updateFiltersAndFetch({ commit, dispatch, state }, filters = {}) {
    try {
      commit('SET_FILTERS', filters);
      commit('SET_PAGINATION', { ...state.pagination, page: 1 });
      await dispatch('fetchAppointments');
      return true;
    } catch (error) {
      console.error('Update filters and fetch failed:', error);
      throw error.response?.data || error;
    }
  },

  async clearFiltersAndFetch({ commit, dispatch }) {
    try {
      commit('SET_FILTERS', {
        status: 'upcoming', // Default to upcoming instead of null
        customer_id: null,
        branch_id: null,
        staff_id: null,
        service_id: null,
        conversation_id: null,
        label: null,
        start_date: null,
        end_date: null,
        sort_by: 'date',
        sort_order: 'asc',
      });

      commit('SET_PAGINATION', {
        page: 1,
        page_size: 10,
        total: 0,
        next: null,
      });

      await dispatch('fetchAppointments');
      return true;
    } catch (error) {
      console.error('Clear filters and fetch failed:', error);
      throw error.response?.data || error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
